import { render, staticRenderFns } from "./NumberedListInner.vue?vue&type=template&id=7e40a2c8&"
import script from "./NumberedListInner.vue?vue&type=script&lang=js&"
export * from "./NumberedListInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports